import { action, atom, readonly, withAssign } from '@reatom/framework'
import BigNumber from 'bignumber.js'

import type { BigNumberAtom } from '@root/shared/lib'

export interface AthAtom extends BigNumberAtom {}

export const reatomAth = (value: BigNumber.Value): AthAtom => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const theAtom = atom(BigNumber(value))

  const setAction = action((ctx, value: BigNumber.Value) => {
    const currentValue = ctx.get(theAtom)

    if (currentValue.gte(value)) {
      return
    }

    theAtom(ctx, BigNumber(value))
  }, 'setAction')

  return theAtom.pipe(
    readonly,
    withAssign(() => ({
      set: setAction,
    })),
  )
}
